module.exports = "./img/3027df4810eaa5af090cf59505a4ddf3.jpg";